import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Indicates whether the user has ever selected calendars in Time Panel
 *
 * If not, we should fall back on using Calendar Module selected calendars config
 */
export function hasTimePanelSelectedCalendars(): boolean {
    if (!isFeatureEnabled('cal-time-panel-calendarPicker')) {
        return false;
    }

    // TODO: VSO #54134 Adjust logic within feature flight so that user nevers falls back to Calendar Module config after first use
    const selectedCalendarsMap = getStore().calendarIdsMap;

    let calendarsCount = 0;
    for (let value of selectedCalendarsMap.values()) {
        if (value) {
            calendarsCount += value.length;
        }
    }

    return calendarsCount > 0;
}
